import { XrinvData } from '../../types/comms-check';

export type TcsoBlocker = 'SMETS1' | 'UNKNOWN_SMETS_VERSION';

export const BLOCKER_TEXT: Record<TcsoBlocker, string> = {
  SMETS1: 'Smets1 device is not supported.',
  UNKNOWN_SMETS_VERSION: 'Unable to determine smets version.',
};

export const CONTACT_SST_FOR_SUPPORT = 'Please contact SST for support.';

/**
 * Inventory rules that stop a TCSO even when the meters are in comms: the automation only
 * supports SMETS2 hubs. The PPMID is ignored. SMETS1 is reported ahead of an unknown version.
 */
export function findSmetsBlocker(devices: XrinvData[]): TcsoBlocker | null {
  const siteDevices = devices.filter((device) => device.deviceType !== 'PPMID');
  if (siteDevices.some((device) => device.smetsDeviceType === 'Smets 1')) {
    return 'SMETS1';
  }
  if (siteDevices.some((device) => device.smetsDeviceType === 'Unknown')) {
    return 'UNKNOWN_SMETS_VERSION';
  }
  return null;
}
